import React, { FC } from 'react';
import classnames from 'classnames';
import { CSSTransition } from 'react-transition-group';
import { Container } from '@src/components/Container';
import { DefaultPopoverProps } from './props';
import './styles.scss';

export const DefaultPopover: FC<DefaultPopoverProps> = ({ children, isShown, className }) => {
  const popoverClassName = classnames('fr-popover', className);

  return (
    <CSSTransition classNames="fr-popover" in={isShown} mountOnEnter timeout={150} unmountOnExit>
      <Container className={popoverClassName} onClick={e => e.stopPropagation()} type="popover">
        {children}
      </Container>
    </CSSTransition>
  );
};
